<div class="p-5 cont" dir="rtl">
    <h5>كيف يعمل :-</h5>

    <p>يعمل صالون PURE  عن طريق المواعيد  فقط لدينا احترام كبير لأوقات عملائنا ..
        يسمح بإلغاء الحجز او تعديله قبل الموعد ب 3 ساعات على الاقل تجنبآ لحظر الرقم 
        في حآل الرغبة في تبديل الموعد بموعد اخر يتم مراجعة الموعد الجديد حال توفره من عدمه
        لا يسمح بالتأخير أكثر من 10 دقائق عن الموعد
        في حال حجز خدمآت الشعر غير متطابق مع الأطوال المعتمدة سوف يتم احتساب الفرق قبل عمل الخدمة بالصالون</p>

</div>